import React, { type FC, useState } from 'react';

import Column from '@amzn/meridian/column';
import Link from '@amzn/meridian/link';
import Popover, { PopoverHeader } from '@amzn/meridian/popover';
import Text from '@amzn/meridian/text';
import useHover from 'src/hooks/useHover';

import EmDash from './emdash';

// TODO: move this to a constant file; just not sure where yet.
const MAX_MODIFIED_DUTY_DAYS = 180;

interface ModifiedDutyProps {
  value?: number;
}

const ModifiedDuty: FC<ModifiedDutyProps> = ({ value }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const linkRef = useHover(
    () => setIsPopoverOpen(true),
    () => setIsPopoverOpen(false),
  );

  return (
    <>
      <Link ref={linkRef} type="secondary">
        {value ?? <EmDash />}&nbsp;of {MAX_MODIFIED_DUTY_DAYS} days
      </Link>
      {linkRef.current && (
        <Popover
          anchorNode={linkRef.current}
          open={isPopoverOpen}
          position="bottom"
          onClose={() => setIsPopoverOpen(false)}
          indicatorArrow
          maxWidth="400px"
        >
          <PopoverHeader>Modified Duty Counter</PopoverHeader>
          <Column spacing="400" spacingInset="200">
            <Text type="b300">
              Time in Modified Duty is cumulative between placements occurring at the same time. If the Associate is
              accommodated in two placements (TLD or Modified) only 1 day is accrued.
            </Text>
            <Text type="b300">The ‘days’ in the Modified Duty Counter reset on the rolling calendar year.</Text>
          </Column>
        </Popover>
      )}
    </>
  );
};

export default ModifiedDuty;
